/**
 * @generated SignedSource<<81b3b8e0a31ad4243057ec3d843f9f83>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type TalentAvailability = "AVAILABLE" | "BOOKED" | "UNAVAILABLE" | "%future added value";
export type TalentRole = "COLORIST" | "DIRECTOR" | "DRONE_PILOT" | "EDITOR" | "PHOTOGRAPHER" | "PRODUCER" | "SOUND_ENGINEER" | "VIDEOGRAPHER" | "%future added value";
export type ProfessionalsQuery$variables = Record<PropertyKey, never>;
export type ProfessionalsQuery$data = {
  readonly talent: ReadonlyArray<{
    readonly availability: TalentAvailability;
    readonly bio: string | null | undefined;
    readonly dayRate: any | null | undefined;
    readonly facebookPageName: string | null | undefined;
    readonly facebookPageUrl: string | null | undefined;
    readonly facebookPageVerified: boolean;
    readonly facebookProfileUrl: string | null | undefined;
    readonly headline: string | null | undefined;
    readonly hourRate: any | null | undefined;
    readonly id: string;
    readonly name: string;
    readonly portfolioLinks: ReadonlyArray<{
      readonly label: string;
      readonly url: string;
    }>;
    readonly portraitUrl: string | null | undefined;
    readonly roles: ReadonlyArray<TalentRole>;
    readonly skills: ReadonlyArray<string>;
    readonly slug: string;
  }>;
};
export type ProfessionalsQuery = {
  response: ProfessionalsQuery$data;
  variables: ProfessionalsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "TalentProfile",
    "kind": "LinkedField",
    "name": "talent",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "slug",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "roles",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "headline",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "bio",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "skills",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "dayRate",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hourRate",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "portraitUrl",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "availability",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "PortfolioLink",
        "kind": "LinkedField",
        "name": "portfolioLinks",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "label",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "url",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "facebookProfileUrl",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "facebookPageUrl",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "facebookPageName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "facebookPageVerified",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ProfessionalsQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ProfessionalsQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "7b50354f2ff4e9c833734eb0c2cfc144",
    "id": null,
    "metadata": {},
    "name": "ProfessionalsQuery",
    "operationKind": "query",
    "text": "query ProfessionalsQuery {\n  talent {\n    id\n    name\n    slug\n    roles\n    headline\n    bio\n    skills\n    dayRate\n    hourRate\n    portraitUrl\n    availability\n    portfolioLinks {\n      label\n      url\n    }\n    facebookProfileUrl\n    facebookPageUrl\n    facebookPageName\n    facebookPageVerified\n  }\n}\n"
  }
};
})();

(node as any).hash = "371bafbbf15ef02f8fba7cb1b59eb2e4";

export default node;
